'use client';

import { useSplitAndHeap } from '@/hooks/useSplitAndHeap';
import { QuoteTypeSelector } from '@/app/replace/get-started/components/QuoteTypeSelector';
import { HeadingText } from '@/components/atoms/HeadingText';
import { SpaceWow } from '@/components/SpaceWow';

export interface BestFitQuoteSelectorProps {
	testId?: string;
}

const BestFitQuoteSelector = (props: BestFitQuoteSelectorProps) => {
	const { testId = 'BestFitQuoteSelector' } = props;

	const { ReplaceFootprint } = useSplitAndHeap('ReplaceFootprint');
	const { treatment } = ReplaceFootprint;
	const replaceFootprintBoolean = treatment === 'on' ? true : false;

	if (!replaceFootprintBoolean) return null;

	return (
		<section data-testid={testId} className="hvac-container">
			<HeadingText tag="h2" className="mb-3 lg:mb-4" balanced>
				Find the best fit for you
			</HeadingText>

			<p className="text-balance text-center text-xl tracking-tighter text-black lg:text-2xl">
				We can send one of our trusted HVAC partners to your home or start with
				an initial estimate.
			</p>

			<SpaceWow spacer_10 lg__spacer_14 />
			<QuoteTypeSelector />

			<SpaceWow spacer_10 lg__spacer_20 />
		</section>
	);
};

export default BestFitQuoteSelector;
